import styled, {css} from 'styled-components'
import {Flexbox} from '../flexbox/FlexBox'
import {CSSProperties} from 'react'

type StyledGridProps = {
    className?: string
    $columns: number
    $gap?: number
    $fullWidth?: boolean
    $columnGap?: number
    $rowGap?: number
}
export const StyledGrid = styled.div<StyledGridProps>(
    ({theme: {spacing}, $columns = 1, $gap = 0, $columnGap = 0, $rowGap = 0, $fullWidth}) => css`
        display: grid;
        grid-template-columns: repeat(${$columns}, 1fr);
        ${$gap
            ? css`
                  gap: ${spacing * $gap}px;
              `
            : css`
                  row-gap: ${$rowGap * spacing}px;
                  column-gap: ${$columnGap * spacing}px;
              `}
        ${$fullWidth &&
        css`
            width: 100%;
        `}
    `
)

type StyledGridItemProps = {
    $startColumn?: number
    $endColumn?: number
    $spanColumn?: number
    $justify?: CSSProperties['justifyContent']
}

export const StyledGridItem = styled(Flexbox)<StyledGridItemProps>(
    ({$startColumn, $endColumn, $spanColumn, $justify}) => css`
        grid-column: ${$startColumn && $endColumn
            ? `${$startColumn} / ${$endColumn};`
            : $spanColumn
              ? `span ${$spanColumn}`
              : 'span 1'};
        justify-content: ${$justify ?? 'normal'};
    `
)
